import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const LeadGenerationApi = createApi({
  reducerPath: "leadGenerationApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    //customer side
    leadGeneration: builder.mutation({
      query: (body) => ({
        url: "v1/gc/leads/",
        method: "POST",
        body,
      }),
    }),

    //Admin side
    forwardCurrentLead: builder.mutation({
      query: ({ selectedLead, body }) => ({
        url: `v1/gc/leads/${selectedLead.id}/`,
        method: "POST",
        body,
      }),
    }),

    getAllLeads: builder.query({
      query: ({ page, page_size, start_date, end_date, status }) => ({
        url: `v1/gc/leads/filter_by_date/?page=${page}&page_size=${page_size}&start_date=${start_date}&end_date=${end_date}&status=${status}`,
        method: "GET",
      }),
    }),

    //Home page side
    getStates: builder.query({
      query: () => ({
        url: `v1/gc/leads/workshop-states/`,
        method: "GET",
      }),
    }),

    getCities: builder.query({
      query: (selectedStateName) => ({
        url: `v1/gc/leads/workshop-cities/?state=${selectedStateName}`,
        method: "GET",
      }),
    }),

    // v1/gc/leads/by-workshop/?workshop_id=1
    getWorkshops: builder.query({
      query: ({ selectedStateId, selectedCityId }) => ({
        url: `v1/gc/leads/workshop-locations/?state=${selectedStateId}&city=${selectedCityId}`,
        method: "GET",
      }),
    }),

    // /v1/gc/leads/follow-up/

    getLeadsByWorkshop: builder.query({
      query: ({
        workshopId,
        page,
        page_size,
        start_date,
        end_date,
        status,
      }) => ({
        url: `v1/gc/leads/by-workshop/?workshop_id=${workshopId}&page=${page}&page_size=${page_size}&start_date=${start_date}&end_date=${end_date}&status=${status}`,
        method: "GET",
      }),
    }),

    //update status
    statusUpdate: builder.mutation({
      query: ({ body, selectedLead }) => ({
        url: `v1/gc/leads/follow-up/ `,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLeadGenerationMutation,
  useForwardCurrentLeadMutation,
  useGetAllLeadsQuery,
  useGetStatesQuery,
  useGetCitiesQuery,
  useGetWorkshopsQuery,
  useGetLeadsByWorkshopQuery,
  useStatusUpdateMutation,
} = LeadGenerationApi;
